import { createI18n } from 'vue-i18n'
import it from './locales/it.js'

const LOCALE_KEY = 'app_locale'
const savedLocale = localStorage.getItem(LOCALE_KEY) || 'it'

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'it',
  messages: { it },
  missingWarn: false,
  fallbackWarn: false,
})

export function setLocale(locale) {
  i18n.global.locale.value = locale
  localStorage.setItem(LOCALE_KEY, locale)
}

export { useI18n } from 'vue-i18n'
export default i18n
